<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="large"
  color="#fff"
  type="ball-clip-rotate">
    <p style="margin-top: 80px; font-size: 20px; color: white">{{ 'APP.LOADING' | translate }}</p>
</ngx-spinner>
<router-outlet></router-outlet>
